var React = require('react');

function Logout (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("path",{"d":"m4.385 43.745c2.707 6.365 7.53 11.6 13.653 14.819 6.124 3.217 13.171 4.221 19.949 2.84 6.778-1.382 12.871-5.063 17.247-10.42 4.376-5.358 6.766-12.063 6.766-18.98 0-6.918-2.39-13.623-6.766-18.98-4.376-5.358-10.469-9.039-17.247-10.42s-13.825-0.378-19.949 2.84c-6.123 3.218-10.946 8.453-13.653 14.819","key":0}),React.createElement("path",{"d":"m33.308 42.44 10.437-10.436-10.437-10.436","key":1}),React.createElement("path",{"d":"m43.745 32.006h-41.745","key":2})]));
}

Logout.defaultProps = {"clipRule":"evenodd","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","version":"1.1","viewBox":"0 0 64 64","xmlSpace":"preserve"};

module.exports = Logout;

Logout.default = Logout;
